import React, { useEffect, useState } from 'react';
import { createShippoShipment } from '../CheckoutPage.duck';
import css from './StripePaymentForm.module.css';
import shippoCss from './ShippoShipment.module.css';
import classNames from 'classnames';
import Spinner from '../../../components/IconSpinner/IconSpinner';

const ShippoShipment = props => {
  const [formData, setFormData] = useState({});
  const { data, listing, setCurrentShipment, currentShipment,formId,formApi,delivery_amount } = props;
  const [shippoShipment, setShippoShipment] = useState();
  const [toggleDropDown, setToggleDropDown] = useState(false);

  useEffect(()=>{ 
    if(!delivery_amount && !currentShipment, shippoShipment?.rates?.length > 0){
      // formApi.change('delivery_amount', shippoShipment?.rates[0]?.amount);

      // setCurrentShipment(shippoShipment?.rates[0])
    }
  },[shippoShipment?.rates[0]])

  const getMapboxQueryData = (arr, key, field) => {
    return arr?.find(a => a.id.includes(key))?.[field];
  };

  const formatMapBoxData = mapboxdata => {
    let matchedAddress = mapboxdata.features[0];
    console.log('matchedAddressmatchedAddress', mapboxdata);
    let country =
      getMapboxQueryData(matchedAddress?.context, 'country', 'short_code') ||
      getMapboxQueryData(mapboxdata.features, 'country', 'short_code') ||
      'US';
    let street1 =
      getMapboxQueryData(matchedAddress?.context, 'poi', 'short_code') ||
      getMapboxQueryData(mapboxdata.features, 'poi', 'short_code');
    let zip =
      getMapboxQueryData(matchedAddress?.context, 'postcode', 'text') ||
      getMapboxQueryData(mapboxdata.features, 'postcode', 'text');
    let city =
      getMapboxQueryData(matchedAddress?.context, 'place', 'text') ||
      getMapboxQueryData(mapboxdata.features, 'place', 'text');
    let state =
      getMapboxQueryData(matchedAddress?.context, 'region', 'text') ||
      getMapboxQueryData(mapboxdata.features, 'region', 'text');

    let formDataObj = { country, city, zip, state, street1 };

    setFormData({ ...formData, addressFrom: formDataObj });

    return formDataObj;
  };
  const getFromAdress = async () => {
    let addressData = listing?.attributes?.publicData?.location?.address;
    let response = await fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${addressData}.json?access_token=${process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}`
    )
      .then(response => response.json())
      .then(data => formatMapBoxData(data))
      .catch(error => console.error('Error:', error));
  };

  useEffect(() => {
    if (!formData?.addressFrom) {
      getFromAdress();
    }
    const addressTo = {
      name: data?.name,
      street1: data?.recipientAddressLine1,
      city: data?.recipientCity,
      state: data?.recipientState,
      zip: data?.recipientPostal,
      country: data?.recipientCountry,
      phone: data?.recipientPhoneNumber,
    };

    let filteredAddressData = Object.fromEntries(Object.entries(addressTo).filter(([_, v]) => !!v));

    setFormData({ ...formData, addressTo: filteredAddressData });
  }, [data]);

const [rateLoading,setRateLoading]=useState(false)
  useEffect(() => {
    setRateLoading(true)
    createShippoShipment(formData)
      .then(response => {
        if (response?.shipment) {
          setShippoShipment({ ...response?.shipment });
          // setCurrentShipment({});
          setRateLoading(prev=> !prev)
        }
      })
      .catch(error => {
        console.log('Error', error);
        setRateLoading(prev=> !prev)

      });
  }, []);
  return (rateLoading ? <div className={shippoCss.icon_container}><Spinner /></div> : 
    <div className={shippoCss.shippo_main_container}>
      <div className={shippoCss.shippoShipment_dropdown}>
        {currentShipment?.amount ?
        <div
          className={`${shippoCss.shippo_dropdownselector} ${shippoCss.shippo_ship_card}`}
          onClick={() => {setToggleDropDown(!toggleDropDown)}}
        >
          <div className={shippoCss.card_top_sec}>
            <div className={shippoCss.ship_img_wrapper}>
              <img src={currentShipment?.provider_image_200} />
            </div>
            <div className={shippoCss.shipment_desc}>
              <div className={shippoCss.rate_name}>
                {currentShipment?.servicelevel?.display_name || currentShipment?.servicelevel?.name}
              </div>
              <div className={shippoCss.price_wrapper}>
                <span className={shippoCss.label_wrapper}>Price</span>
                <span>$ {currentShipment?.amount}</span>
              </div>
            </div>
          </div>
        </div>
          :
          <span className={`${shippoCss.label_wrapper} buttonPrimary `}
          onClick={() => {setToggleDropDown(!toggleDropDown)}}
          >Select Shipping Method</span>

}
          {/* <div className={shippoCss.bottom_sec}>
            <span className={shippoCss.duration_text}>{currentShipment?.duration_terms}</span>
          </div> */}
        
        {toggleDropDown && (
          <div className={shippoCss.shipping_rates_dropdown_list}>

            {shippoShipment?.rates?.map((rate, index) => {
              return (
                <div
                  className={classNames(
                    shippoCss.shippo_ship_card,
                    currentShipment?.object_id === rate?.object_id ? shippoCss?.selected : ''
                  )}
                  key={`shippoCard${index}`}
                  onClick={() => {
                    setCurrentShipment();

                    setCurrentShipment(rate);

                    formApi.change('delivery_amount', rate?.amount);
                    setToggleDropDown(!toggleDropDown)
                  }}
                >
                  <div className={shippoCss.card_top_sec}>
                    <div className={shippoCss.ship_img_wrapper}>
                      <img src={rate?.provider_image_200} />
                    </div>
                    <div className={shippoCss.shipment_desc}>
                      <div className={shippoCss.rate_name}>
                        {rate?.servicelevel?.display_name || rate?.servicelevel?.name}
                      </div>
                      <div className={shippoCss.price_wrapper}>
                        <span className={shippoCss.label_wrapper}>Price</span>
                        <span>$ {rate?.amount}</span>
                      </div>
                    </div>
                  </div>
                  <div className={shippoCss.bottom_sec}>
                    <span className={shippoCss.duration_text}>{rate?.duration_terms}</span>
                  </div>
                </div>
              );
            })}
          </div>
        )}
        
      </div>
    </div>
  );
};

export default ShippoShipment;
